import { useMutation, useQueryClient } from "@tanstack/react-query";
import { companyApi, companyQueryKeys } from "service/crm/api/company";
import { Company, CreateContactCompanyPayload } from "types/crm/company";
import { contactQueryKeys } from "../api/contact";

export const useCreateContactCompanyMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (
      payload: CreateContactCompanyPayload & { contactUuid: string },
    ): Promise<Company> => companyApi.createCompanyForContact(payload),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: companyQueryKeys.byContact(variables.contactUuid),
      });
      queryClient.invalidateQueries({ queryKey: companyQueryKeys.all });
      queryClient.invalidateQueries({
        queryKey: contactQueryKeys.activities(variables.contactUuid),
      });
    },

  });
};
